// Web Route
import Home from "../pages/Home";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import ContactUs from "../pages/ContactUs";
import Pricing from "../component/web/pricing";
import Guidelines from "../pages/Guidelines";
import Highlights from "../pages/Highlights";
import ForgotPass from "../pages/ForgotPass";
import SetPassword from "../pages/SetPassword";
import SetOwnPassword from "../pages/SetOwnPassword";

// School Admin Portal Routes
import SchoolAdminFeed from "../pages/SchoolAdminFeed";
import schoolAdminData from "../pages/SchoolAdminData";
import schoolCoaches from "../pages/SchoolCoaches";
import SchoolAdminCoachDetails from "../pages/SchoolAdminCoachDetails";
import SchoolAthletes from "../pages/SchoolAthletes";
import schoolGroups from "../pages/SchoolGroups";
import SchoolTeams from "../pages/SchoolTeams";
import CreateTeam from "../pages/CreateTeam";
import AthleteDetails from "../pages/AthleteDetails";
import TeamDetails from "../pages/TeamDetails";
import EditTeams from "../pages/EditTeams";
import SchoolTeamsCoaches from "../pages/SchoolTeamsCoaches";
import SchoolTeamsAthelete from "../pages/SchoolTeamsAthelete";
import SchoolGameHistory from "../pages/SchoolGameHistory";
import VideoLibrary from "../pages/VideoLibrary";
import UploadVideo from "../pages/UploadVideo";
import UploadVideos from "../pages/UploadVideos";
import SelectedVideos from "../pages/SelectedVideos";
import VideoMerge from "../component/schoolAdminPortal/VideoMerge";
import Cameras from "../component/schoolAdminPortal/Cameras";
import VideoPlayer from "../component/schoolAdminPortal/videoPlayer/VideoPlayer";
import profileManagement from "../component/schoolAdminPortal/profileManagement";
import coachpfmgmt from "../component/schoolAdminPortal/coachpfmgmt";
import coachprofile from "../component/schoolAdminPortal/coachprofile.js";
import BillingDetails from "../component/schoolAdminPortal/BillingDetails";
// Super Admin Routes
import Storage from "../pages/Storage";
import Website from "../pages/Website";
import Payment from "../pages/Payment";
import Schools from "../pages/Schools";
import Breakdown from "../pages/Breakdown";
import SchoolAdmin from "../pages/SchoolAdmin";
import DashboardData from "../pages/DashboardData";
import EditSchools from "../pages/EditSchools";
import SchoolNameScreen from "../pages/SchoolNameScreen";
import SuperAdminAthlets from "../pages/SuperAdminAthlets";
import SuperAdminCoaches from "../pages/SuperAdminCoaches";
import StorageDetails from "../pages/StorageDetails";
import AddSchoolAthlete from "../pages/AddSchoolAthlete";
import EditSchoolAdmin from "../pages/EditSchoolAdmin";
import EditPaymentBill from "../pages/EditPaymentBill";
import WebsiteDetails from "../component/superAdmin/WebsiteDetails";
import LandingPageDetails from "../component/superAdmin/LandingPageDetails";
import guidelinedetails from "../component/superAdmin/guidelinedetails";
import highlightsdetails from "../component/superAdmin/highlightsdetails";
import paymentSchoolDetails from "../component/superAdmin/paymentSchoolDetails";
import LiveStream from "../component/superAdmin/LiveStreamStatus";

// Coaches Routes
import SelectCoachDashboard from "../pages/SelectCoachDashboard";
import SchoolEvents from "../component/schoolAdminPortal/SchoolEvents";
import CreateEvents from "../component/schoolAdminPortal/CreateEvents";
import EditEvent from "../component/schoolAdminPortal/EditEvent";

// Trending
import Trending from "../component/schoolAdminPortal/Trending";
import IntercutVideo from "../component/schoolAdminPortal/Intercut Video/IntercutVideo";
import Groups from "../component/schoolAdminPortal/Groups";
import AddGroup from "../component/schoolAdminPortal/Groups/AddGroup";
import EditGroups from "../component/schoolAdminPortal/Groups/EditGroups";
import GroupsDetails from "../component/schoolAdminPortal/Groups/GroupsDetails";
import EditCompletedEvents from "../component/schoolAdminPortal/EditCompletedEvents";
import Pfmgmt from "../component/schoolAdminPortal/Pfmgmt";
import AddAtheleteWebsite from "../component/schoolAdminPortal/atheleteAddWebsite";
import EditSchoolProfile from "../component/schoolAdminPortal/ProfileEditManagement";

//HEIGHLIGHTS
import SchoolHighlights from "../component/schoolAdminPortal/SchoolHighlights";
import CreateHighlight from "../component/schoolAdminPortal/CreateHighlight";
import PdfTorn from "../component/schoolAdminPortal/PdfTorn";
import VideoEditor from "../component/schoolAdminPortal/VideoEditor";
import HighlightMerge from "../component/schoolAdminPortal/HighlightMerge";
import PdfTronHome from "../component/schoolAdminPortal/PdfTronHome";
import PdfTronHighlight from "../component/schoolAdminPortal/pdftronHighlight";
import pdftronHighlightEdit from "../component/schoolAdminPortal/pdftronHighlightEdit";

// Activity History
import ActivityHistory from "../component/schoolAdminPortal/ActivityHistory";
import AdminContactUs from "../component/superAdmin/AdminContactUs";
import AdminNewsLetter from "../component/superAdmin/AdminNewsLetter";
import ContactUsDetails from "../component/superAdmin/ContactUsDetails";
import SchoolAdminStorage from "../component/schoolAdminPortal/SchoolAdminStorage/SchoolAdminStorage";
import Reports from "../component/schoolAdminPortal/SchoolAdminPages/Reports";
import Renewals from "../component/schoolAdminPortal/SchoolAdminPages/Renewals";
import TeamAdmin from "../component/schoolAdminPortal/ShoolAdminTeams/TeamAdmin";
import AddOrEditSchoolAdminTeam from "../component/schoolAdminPortal/ShoolAdminTeams/AddOrEditSchoolAdminTeam ";
import TeamAdminDetails from "../component/schoolAdminPortal/ShoolAdminTeams/TeamAdminDetails";
import Hours from "../component/schoolAdminPortal/SchoolAdminPages/Hours";
import Sports from "../component/schoolAdminPortal/SchoolAdminPages/Sports";
import HoursGraphChart from "../component/schoolAdminPortal/SchoolAdminPages/HoursGraphChart/HoursGraphChart";
import AddOrEditSports from "../component/schoolAdminPortal/SchoolAdminPages/AddOrEditSports";
import SportsDetails from "../component/schoolAdminPortal/SchoolAdminPages/SportsDetails";
import TeamAdminProfile from "../component/schoolAdminPortal/ShoolAdminTeams/TeamAdminProfile";
import AthleteProfileDetails from "../component/schoolAdminPortal/Athlete/AthleteProfileDetails";
import EditAthleteProfile from "../component/schoolAdminPortal/Athlete/EditAthleteProfile";
import TeamAdminProfileDetails from "../component/schoolAdminPortal/ShoolAdminTeams/TeamAdminProfileDetails";
import StorageRequest from "../component/superAdmin/StorageRequest";
import Seasons from "../component/schoolAdminPortal/Seasons/Seasons";
import HoursGraphContainer from "../component/schoolAdminPortal/SchoolAdminPages/HoursGraphChart/HoursGraphContainer";
import VideoStreamingContainer from "../component/schoolAdminPortal/Video Streaming/VideoStreamingContainer";
import CoachDetails from "../component/schoolAdminPortal/Coaches/CoachDetails";
import AddEditCoach from "../component/schoolAdminPortal/Coaches/AddEditCoach";
import AddEditAthlete from "../component/schoolAdminPortal/Athlete/AddEditAthlete";
import CreateVideoStreamingChannel from "../component/superAdmin/Manage Video Streaming/CreateVideoStreamingChannel";
import VideoStreamingDashboard from "../component/schoolAdminPortal/Video Streaming/VideoStreamingDashboard";
import VideoStreamingDashboardContainer from "../component/schoolAdminPortal/Video Streaming/VideoStreamingDashboardContainer";
import AddAvsDetails from "../component/superAdmin/Manage Video Streaming/AddAvsDetails";
import VideoHighlight from "../component/schoolAdminPortal/Video Highlights/VideoHighlights";
import IvsChannelList from "../component/superAdmin/Manage Video Streaming/IvsChannelList";
import RealTimeStreamingDashboardContainer from "../component/schoolAdminPortal/RealTimeStreaming/RealTimeStreamingDashboardContainer.js";
export const routes = [
  {
    path: "/",
    component: Home,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/contactus",
    component: ContactUs,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/guidelines",
    component: Guidelines,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/highlights",
    component: Highlights,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/CreateHighlight",
    component: CreateHighlight,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/profileManagement"],
    component: profileManagement,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/coachprofile"],
    component: coachprofile,
    exact: true,
    isProtected: true,
  },
  {
    path: "/pricing",
    component: Pricing,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/SignUp",
    component: SignUp,
    exact: true,
    isProtected: false,
    addHeaderFooter: true,
  },
  {
    path: "/login",
    component: Login,
    exact: true,
    isProtected: false,
  },
  {
    path: "/forgotpassword",
    component: ForgotPass,
    exact: true,
    isProtected: false,
  },

  {
    path: ["/paymentSchoolDetails", "/paymentSchoolDetails/:schoolId"],
    component: paymentSchoolDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/setpassword",
    component: SetPassword,
    exact: true,
    isProtected: false,
  },
  {
    path: "/setownpassword",
    component: SetOwnPassword,
    exact: true,
    isProtected: false,
  },
  // Private Routes
  {
    path: ["/superadmindashboard", "/dashboarddata"],
    component: DashboardData,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schools",
    component: Schools,
    exact: true,
    isProtected: true,
  },
  {
    path: "/add-school",
    component: SchoolAdmin,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/highlightsdetails", "/highlightsdetails/:requestId"],
    component: highlightsdetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/storage",
    component: Storage,
    exact: true,
    isProtected: true,
  },
  {
    path: "/website",
    component: Website,
    exact: true,
    isProtected: true,
  },
  {
    path: "/liveStreamStatus",
    component: LiveStream,
    exact: true,
    isProtected: true,
  },
  {
    path: "/payment",
    component: Payment,
    exact: true,
    isProtected: true,
  },
  {
    path: "/breakdownRequests",
    component: Breakdown,
    exact: true,
    isProtected: true,
  },
  {
    path: [
      "/schoolnamescreen/:schoolId",
      "/schoolnamescreen/:schoolId/:storageId",
    ],
    component: SchoolNameScreen,
    exact: true,
    isProtected: true,
  },
  {
    path: "/editschooldetails/:schoolId",
    component: EditSchools,
    exact: true,
    isProtected: true,
  },
  {
    path: [
      "/schooladmindashboard",
      "/schooladminfeed",
      "/coachdashboard",
      "/athletedashboard",
      "/teamadmindashboard",
    ],
    component: SchoolAdminFeed,
    exact: true,
    isProtected: true,
  },
  {
    path: "/superadminathlets",
    component: SuperAdminAthlets,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolathlete",
    component: SuperAdminCoaches,
    exact: true,
    isProtected: true,
  },
  {
    path: "/storagedetails",
    component: StorageDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schooladmindata",
    component: schoolAdminData,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolhighlights",
    component: SchoolHighlights,
    exact: true,
    isProtected: true,
  },
  {
    path: "/highlightmerge",
    component: HighlightMerge,
    exact: true,
    isProtected: true,
  },

  {
    path: "/pdfTronhome",
    component: PdfTronHome,
    exact: true,
    isProtected: true,
  },

  {
    path: "/PdfTronHighlight",
    component: PdfTronHighlight,
    exact: true,
    isProtected: true,
  },
  {
    path: "/pdftronHighlightEdit",
    component: pdftronHighlightEdit,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolcoaches",
    component: schoolCoaches,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schooladmincoachdetails",
    component: SchoolAdminCoachDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/addschoolcoaches", "/editcoaches/:coachId"],
    component: AddEditCoach,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolathletes",
    component: SchoolAthletes,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolgroups",
    component: schoolGroups,
    exact: true,
    isProtected: true,
  },
  {
    path: "/saddSchoolathlete",
    component: AddSchoolAthlete,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/teamdetails", "/teamdetails/:teamId"],
    component: TeamDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/editteams/:teamId",
    component: EditTeams,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolteamscoaches",
    component: SchoolTeamsCoaches,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolteamsathelete",
    component: SchoolTeamsAthelete,
    exact: true,
    isProtected: true,
  },
  {
    path: "/schoolgamehistory",
    component: SchoolGameHistory,
    exact: true,
    isProtected: true,
  },
  {
    path: "/videolibrary",
    component: VideoLibrary,
    exact: true,
    isProtected: true,
  },
  {
    path: "/createteam",
    component: CreateTeam,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/coachesdetails", "/coachesdetails/:coacheId"],
    component: CoachDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/athletedetails/:athleteId",
    component: AthleteDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/editschooladmin",
    component: EditSchoolAdmin,
    exact: true,
    isProtected: true,
  },
  {
    path: "/uploadvideo",
    component: UploadVideo,
    exact: true,
    isProtected: true,
  },
  {
    path: "/uploadvideos",
    component: UploadVideos,
    exact: true,
    isProtected: true,
  },
  {
    path: "/selectedvideos",
    component: SelectedVideos,
    exact: true,
    isProtected: true,
  },
  {
    path: "/billingDetails",
    component: BillingDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/selectcoachdashboard",
    component: SelectCoachDashboard,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/schoolevents", "/schoolevents/:tabvalue"],
    component: SchoolEvents,
    exact: true,
    isProtected: true,
  },
  {
    path: "/EditPaymentBill",
    component: EditPaymentBill,
    exact: true,
    isProtected: true,
  },
  {
    path: "/WebsiteDetails",
    component: WebsiteDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/guidelinedetails",
    component: guidelinedetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/landingpagedetails",
    component: LandingPageDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/admincontactus", "/admincontactus/:notificationId"],
    component: AdminContactUs,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/adminnewsletter",],
    component: AdminNewsLetter,
    exact: true,
    isProtected: true,
  },

  {
    path: ["/contactusdetails", "/contactusdetails/:notificationId"],
    component: ContactUsDetails,
    exact: true,
    isProtected: true,
  },

  {
    path: "/videomerge",
    component: VideoMerge,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/trending"],
    component: Trending,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/groups"],
    component: Groups,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/addgroup"],
    component: AddGroup,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/editgroup", "/editgroup/:groupId"],
    component: EditGroups,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/groupdetails", "/groupdetails/:groupId"],
    component: GroupsDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/editcompletedevents", "/editcompletedevents/:eventId"],
    component: EditCompletedEvents,
    exact: true,
    isProtected: true,
  },

  {
    path: ["/pfmanagement"],
    component: Pfmgmt,
    exact: true,
    isProtected: true,
  },

  {
    path: ["/events"],
    component: SchoolEvents,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/reports"],
    component: Reports,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/renewals"],
    component: Renewals,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/teamadmin"],
    component: TeamAdmin,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/addteamadmin"],
    component: AddOrEditSchoolAdminTeam,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/editteamadmin/:teamId"],
    component: AddOrEditSchoolAdminTeam,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/teamadmindetails/:teamId"],
    component: TeamAdminDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/videoplayer"],
    component: VideoPlayer,
    exact: true,
    isProtected: true,
  },

  {
    path: "/cameras",
    component: Cameras,
    exact: true,
    isProtected: true,
  },
  {
    path: [
      "/videoplayer",
      "/videoplayer/:videoplayerId",
      "/videoPlayer?seasonId=:evId&eventId=:plId&weekId=:ctId&eventCategory=:eventCategory&off-season-eventName=:off-season-eventName&practice=:practice&otherEventType=:otherEventType",
    ],
    component: VideoPlayer,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/intercutvideo"],
    component: IntercutVideo,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/profileEditPage", "/profileEditPage/:schoolId"],
    component: EditSchoolProfile,
    exact: true,
    isProtected: true,
  },

  {
    path: ["/pdftron", "/pdftron/:videoplayerId"],
    component: PdfTorn,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/videoeditor", "/videoeditor/:videoplayerId"],
    component: VideoEditor,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/coachpfmgmt"],
    component: coachpfmgmt,
    exact: true,
    isProtected: true,
  },

  {
    path: ["/addAtheleteWebsite", "/addAtheleteWebsite/:token"],
    component: AddAtheleteWebsite,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/storageManagement"],
    component: SchoolAdminStorage,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/hours"],
    component: Hours,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/hoursgrapschart/:sportId"],
    component: HoursGraphContainer,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/requestHours"],
    component: StorageRequest,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/sports"],
    component: Sports,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/addsports"],
    component: AddOrEditSports,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/editsports/:sportsId"],
    component: AddOrEditSports,
    exact: true,
    isProtected: true,
  },
  {
    path: ["/sportdetails/:sportsId"],
    component: SportsDetails,
    exact: true,
    isProtected: false,
  },
  {
    path: "/manageteamadminprofile",
    component: TeamAdminProfile,
    exact: true,
    isProtected: false,
  },
  {
    path: ["/addathlete", "/editathlete/:athleteId"],
    component: AddEditAthlete,
    exact: true,
    isProtected: true,
  },
  {
    path: "/athleteprofiledetails",
    component: AthleteProfileDetails,
    exact: true,
    isProtected: false,
  },
  {
    path: "/editathleteprofile",
    component: EditAthleteProfile,
    exact: true,
    isProtected: false,
  },

  {
    path: "/teamadminprofiledetails",
    component: TeamAdminProfileDetails,
    exact: true,
    isProtected: false,
  },
  {
    path: "/seasons",
    component: Seasons,
    exact: true,
    isProtected: true,
  },
  {
    path: "/videostreaming",
    component: VideoStreamingContainer,
    exact: true,
    addHeaderFooter: true,
  },
  {
    path: "/managevideostreaming",
    component: CreateVideoStreamingChannel,
    exact: true,
    isProtected: true,
  },
  {
    path: "/videostreamingforschooladmin",
    component: VideoStreamingDashboardContainer,
    exact: true,
    isProtected: true,
  },
  //Real time streaming
  {
    path: "/realTimeStreaming",
    component: RealTimeStreamingDashboardContainer,
    exact: true,
    isProtected: true,
  },
  {
    path: "/addavsdetails",
    component: AddAvsDetails,
    exact: true,
    isProtected: true,
  },
  {
    path: "/createvideohighlights",
    component: VideoHighlight,
    exact: true,
    isProtected: true,
  },
  {
    path: "/allIVSChannelList",
    component: IvsChannelList,
    exact: true,
    isProtected: true,
  },
];
